import React from 'react';

const JSON_Data_Types = () => {
  return (
    <div >
      <h1>JSON_Data_Types</h1>
      <p>Placeholder component for: "JSON Data Types"</p>
    </div>
  );
};

export default JSON_Data_Types;
